import { TableCellWithBadge } from "../../../../data-model/tableCells";

const OPEN_BADGE = {
  text: "Open",
  textColor: "#005D49",
  bgColor: "#E6F3F0",
};

const CLOSED_BADGE = {
  text: "Closed",
  textColor: "#DC2626",
  bgColor: "#FEE2E2",
};

/**
 * Determines whether an order should display as Closed based on sftp_status.
 * Closed when sftp_status is success; Open when resubmit, null, or empty.
 *
 * @input sftpStatus - Raw sftp_status from the order row
 * @return boolean: True when the order should show a Closed badge
 */
export const isOrderClosed = (
  sftpStatus: string | null | undefined,
): boolean => {
  return (sftpStatus ?? "").trim().toLowerCase() === "success";
};

/**
 * Returns Open/Closed badge styles for the Order Status column.
 *
 * @input sftpStatus - Raw sftp_status from the order row
 * @return TableCellWithBadge: Badge cell value for Open or Closed
 */
export const getOrderStatusBadgeStyles = (
  sftpStatus: string | null | undefined,
): TableCellWithBadge => {
  const closed = isOrderClosed(sftpStatus);
  const styles = closed ? CLOSED_BADGE : OPEN_BADGE;

  return {
    text: styles.text,
    color: styles.textColor,
    bgColor: styles.bgColor,
    hoverText: styles.text,
  };
};
